/**
 * Restschuld-Berechnung für Mietwagen-Akten (Issue #615)
 *
 * Formel: Tagessatz × Mietdauer − Versicherungs-Zahlungen = Restschuld
 */

export function berechneMietdauerTage(
  mietbeginn: string | null | undefined,
  mietende: string | null | undefined,
): number {
  if (!mietbeginn || !mietende) return 0;
  const start = new Date(mietbeginn).getTime();
  const end = new Date(mietende).getTime();
  if (isNaN(start) || isNaN(end) || end <= start) return 0;
  return Math.ceil((end - start) / (1000 * 60 * 60 * 24));
}

export function berechneRestschuld(
  tagessatz: number,
  mietdauerTage: number,
  zahlungenGesamt: number,
): number {
  return tagessatz * mietdauerTage - zahlungenGesamt;
}
